import { saturate, darken, desaturate, lighten } from 'polished'
import { type Workspace } from '@/features/iam/workspaces/Workspace'
import { design } from '@/infra/design'
import { toEffectiveTheme } from '@/features/shell/theming/effective-theme'

function setBodyCssVar(variable: string, value: string) {
  document.body.style.setProperty(variable, value)
}

/**
 * Sets the theme CSS variables from the workspace's branding.
 */
export function setBrandingVariables(workspace: Workspace) {
  const { brand, accent } = toEffectiveTheme(
    workspace.branding.colors.primary,
    design,
  )

  setBodyCssVar('--theme-base-brand', brand)
  setBodyCssVar('--theme-base', accent)
  setBodyCssVar('--theme-darken', saturate(0.3, darken(0.1, accent)))
  setBodyCssVar('--theme-lighten', desaturate(0.1, lighten(0.3, accent)))
}
